import React, {useEffect, useState} from 'react'
import {Button, Form, Input, message, Modal, Popconfirm} from "antd"
import parseToken from "../../../../../../helpers/parseToken"
import {addSettingTenantParam, updateSettingTenantParam} from "../../../../../../services/api/apiSetting"

const {TextArea} = Input

const ParamActions = ({isOpen, tenantId, onCancel, typeAction, itemEdit, onGetListParam}) => {
    const decodeToken = parseToken()
    const [formRef] = Form.useForm()
    const [loading, setLoading] = useState(false)
    const [isChangeValue, setIsChangeValue] = useState(false)

    const _onChangeValue = (changedValues, allValues) => {
        const listKeys = Object.keys(allValues)

        if (typeAction === 'add') {
            if (listKeys) {
                listKeys.every(function (key, index) {
                    if (changedValues && changedValues?.[key] !== '') {
                        return setIsChangeValue(true)
                    } else {
                        return setIsChangeValue(false)
                    }
                })
            }
        } else {
            if (listKeys && itemEdit && Object.keys(itemEdit).length > 0) {
                listKeys.every(function (key, index) {
                    if (changedValues && itemEdit?.[key] !== changedValues?.[key]) {
                        return setIsChangeValue(true)
                    } else {
                        return setIsChangeValue(false)
                    }
                })
            }
        }

    }

    const _onAddNewParam = async (payload) => {
        try {
            const response = await addSettingTenantParam(payload, decodeToken.sub)
            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }

            setLoading(false)
            message.success('Thêm mới thành công!')
            onGetListParam()
            onCancel()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _onUpdateParam = async (payload) => {
        try {
            const response = await updateSettingTenantParam(payload, decodeToken.sub)
            const {success, error_message} = response

            if (parseInt(success) !== 1) {
                setLoading(false)
                return message.error(error_message)
            }

            setLoading(false)
            message.success('Cập nhật thành công!')
            onGetListParam()
            onCancel()
        } catch (e) {
            setLoading(false)
            message.error(e.message)
        }
    }

    const _onActionParam = async () => {
        const param = {
            parName: formRef.getFieldValue('parName'),
            parValue: formRef.getFieldValue('parValue'),
            parTitle: formRef.getFieldValue('parTitle'),
            status: 1,
            tenantId,
        }

        if (typeAction === 'add') {
            param['id'] = null
            await _onAddNewParam(param)
        } else {
            param['id'] = itemEdit?.id
            await _onUpdateParam(param)
        }
    }

    useEffect(() => {
        if (itemEdit && Object.keys(itemEdit)?.length > 0) {
            formRef.setFieldsValue({
                parName: itemEdit.parName,
                parValue: itemEdit.parValue,
                parTitle: itemEdit.parTitle,
            })
        }
        // eslint-disable-next-line
    }, [itemEdit]);

    return (
        <Modal
            title={typeAction === 'add' ? 'Thêm mới tham số' : 'Sửa tham số'}
            maskClosable={false}
            open={isOpen}
            closeIcon={<></>}
            footer={[
                <div key='action-param' className="Actions d-flex justify-content-end align-items-center">
                    <Popconfirm
                        placement="top"
                        title={typeAction === 'add' ? 'Bạn chắc chắn muốn tạo mới?' : 'Bạn chắc chắn muốn sửa?'}
                        onConfirm={() => {
                            formRef.submit()
                        }}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button key="submit" type="primary" disabled={!isChangeValue || loading} loading={loading}>
                            {typeAction === 'add' ? 'Thêm mới' : 'Cập nhật'}
                        </Button>
                    </Popconfirm>
                    {isChangeValue ? <Popconfirm
                        placement="top"
                        title="Có dữ liệu chưa lưu bạn vẫn muốn thoát?"
                        onConfirm={onCancel}
                        okText="Yes"
                        cancelText="No"
                    >
                        <Button key="back" type="link">
                            Thoát
                        </Button>
                    </Popconfirm> : <Button key="back" type="link" onClick={onCancel}>
                        Thoát
                    </Button>}
                </div>
            ]}
        >
            <Form
                className='FormEdit'
                layout="vertical"
                form={formRef}
                onFinish={_onActionParam}
                onValuesChange={_onChangeValue}
            >
                <Form.Item
                    className='FormField'
                    name='parName'
                    label={
                        <label className="Label">Loại tham số<span className="Required">*</span></label>
                    }
                    rules={[
                        {
                            required: true,
                            message: 'Loại tham số là bắt buộc'
                        }
                    ]}
                >
                    <Input disabled={typeAction !== 'add'} placeholder='Vui lòng nhập loại tham số'/>
                </Form.Item>
                <Form.Item
                    className='FormField'
                    label={
                        <label className="Label">Giá trị<span className="Required">*</span></label>
                    }
                    name='parValue'
                    rules={[
                        {
                            required: true,
                            message: 'Giá trị tham số là bắt buộc'
                        }
                    ]}
                >
                    <Input placeholder='Vui lòng nhập giá trị tham số'/>
                </Form.Item>
                <Form.Item
                    className='FormField'
                    name='parTitle'
                    label={
                        <label className="Label">Mô tả</label>
                    }
                >
                    <TextArea placeholder='Vui lòng nhập mô tả' autoSize={{minRows: 2, maxRows: 6}}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default ParamActions
